import styled from 'styled-components';
import { CustomPagination, Stack } from '@atlas-frontend/sdk';

export const FooterPagination = styled(CustomPagination)`
  margin-left: auto;
`;

export const DirectoryWrapper = styled(Stack)`
  width: 100%;
  max-width: 100em;
  height: 100%;
  margin-right: auto;
  margin-left: auto;
`;
